<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      :src="image"
      height="100%"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <v-list-tile avatar>


          <v-list-tile-avatar
          >
            <v-avatar slot="activator" size="40px">
              <img :src="$store.state.app.me.profile.avatar" :alt="$store.state.app.me.profile.name">
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title class="subheading user-name">
            {{$t('Common.welcome')}}{{name}}
          </v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <div v-for="(link, i) in links" v-if="!link.roles || hasAnyRole(link.roles)">
            <v-list-group
                    v-if="link.children"
                    :key="link.text"
                    v-model="link.active"
                    no-action
            >
              <template slot="activator">
                <v-list-tile class="v-list-item">
                  <v-list-tile-action>
                    <v-icon>{{ link.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ link.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile
                      v-for="(child, j) in link.children"
                      v-if="!child.roles || hasAnyRole(child.roles)"
                      :key="child.text"
                      link
                      :to="child.to"
                      :active-class="color"
                      avatar
                      class="v-list-item pl-3 mb-1"
              >
                <v-list-tile-action>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ child.text}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>


            <v-list-tile
              v-if="!link.children"
              :key="link.text"
              :to="link.to"
              :active-class="color"
              avatar
              class="v-list-item"
            >
              <v-list-tile-action>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title
                v-text="link.text"
              />
            </v-list-tile>
        </div>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({
    logo: '/img/logo.jpg',
    links: [],
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    name: {
        get()
        {
            if (!this.$store.state.app.me || !this.$store.state.app.me.profile || !this.$store.state.app.me.profile.name) {
                return '';
            }

            return this.$store.state.app.me.profile.name;
            //return this.$store.state.app.me.profile.name.split(" ")[0];
        }
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
    if(this.$store.state.app.me.id == -1) {
        this.repositories.user.me({include: 'roles,nextScheduledOvertime,nextTravelWarrant'}).then((response) => {
            this.setMe(response.data.data);
            this.logoutTimer();
        });
    }
    else{
        this.logoutTimer();
    }

    this.links = [{
          to: '/dashboard',
          icon: 'mdi-view-dashboard',
          text: this.$t('Pages.Dashboard.title')
      },
      {
        icon: 'mdi-home',
        text: this.$t('Pages.Users.company_title'),
        roles: [this.UserRoles.ADMIN, this.UserRoles.COMPANY_USERS],
        active:false,
        children: [
          {
            to: '/users',
            icon: 'mdi-account-group',
            text: this.$t('Pages.Users.title'),
            roles: [this.UserRoles.ADMIN,  this.UserRoles.COMPANY_USERS]
          },
          {
            to: '/workplaces',
            icon: 'mdi-briefcase',
            text: this.$t('Pages.Workplaces.title'),
            roles: [this.UserRoles.ADMIN]
          },
          {
            to: '/sectors',
            icon: 'mdi-puzzle',
            text: this.$t('Pages.Sectors.title'),
            roles: [this.UserRoles.ADMIN]
          },
          /*{
              to: '/employee-roles',
              icon: 'mdi-account-star',
              text: this.$t('Pages.EmployeeRoles.title'),
              roles: [this.UserRoles.ADMIN]
            },*/
        ]
      },
      {
        icon: 'mdi-calendar-multiple-check',
        text: this.$t('Pages.Vacations.title'),
        roles: [this.UserRoles.ADMIN, this.UserRoles.REVISER, this.UserRoles.DIRECTOR, this.UserRoles.VACATIONS],
        children: [
          {
            to: '/vacations',
            icon: 'mdi-calendar-multiple-check',
            text: this.$t('Pages.Vacations.title_pending'),
            roles: [ this.UserRoles.REVISER, this.UserRoles.DIRECTOR] //this.UserRoles.ADMIN,
          },
          {
            to: '/vacation-requests',
            icon: 'mdi-calendar-multiple-check',
            text: this.$t('Pages.VacationRequests.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.VACATIONS]
          },
          {
            to: '/collective-vacations',
            icon: 'mdi-hexagon-multiple',
            text: this.$t('Pages.CollectiveVacations.title'),
            roles: [this.UserRoles.ADMIN]
          },
          {
            to: '/holidays',
            icon: 'mdi-calendar-star',
            text: this.$t('Pages.Holidays.title'),
            roles: [this.UserRoles.ADMIN]
          },
        ]
      },
      {
        icon: 'mdi-download',
        text: this.$t('Pages.Reports.title_plural'),
        roles: [ this.UserRoles.ADMIN, this.UserRoles.DIRECTOR, this.UserRoles.REPORTER, this.UserRoles.REVISER, this.UserRoles.LOGISTIC, this.UserRoles.WAREHOUSE],
        children: [
          {
            to: '/reports/vacations',
            icon: 'mdi-file-excel',
            text: this.$t('Pages.Vacations.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.DIRECTOR, this.UserRoles.REPORTER]
          },
          {
            to: '/reports/users',
            icon: 'mdi-file-excel',
            text: this.$t('Pages.Users.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.REPORTER]
          },
          {
            to: '/reports/overtime',
            icon: 'mdi-file-excel',
            text: this.$t('Pages.ScheduledOvertimes.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.REVISER, this.UserRoles.REPORTER]
          },
          {
            to: '/reports/warrants',
            icon: 'mdi-file-excel',
            text: this.$t('Pages.TravelWarrants.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.REPORTER]
          },
          {
            to: '/reports/warehouse-states',
            icon: 'mdi-file-excel',
            text: this.$t('Pages.Warehouses.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.REPORTER, this.UserRoles.WAREHOUSE]
          },
          {
            to: '/reports/user-checkout-forms',
            icon: 'mdi-file-excel',
            text: this.$t('Pages.UserCheckoutForms.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.REPORTER]
          },
        ]
      },
      {
        icon: 'mdi-truck-delivery',
        text: this.$t('Pages.TravelWarrants.title'),
        roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.TRAVEL_WARRANTS],
        children: [
          {
            to: '/travel-warrants',
            icon: 'mdi-checkbook',
            text: this.$t('Pages.TravelWarrants.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.TRAVEL_WARRANTS]
          },
          {
            to: '/travel-warrant-suggestion',
            icon: 'mdi-format-list-checkbox',
            text: this.$t('Pages.TravelWarrantSuggestion.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.TRAVEL_WARRANTS]
          },
          {
            to: '/vehicles',
            icon: 'mdi-truck',
            text: this.$t('Pages.Vehicles.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.TRAVEL_WARRANTS]
          }
        ]
      },
      {
        icon: 'home_work',
        text: this.$t('Pages.Warehouses.title'),
        roles: [this.UserRoles.ADMIN, this.UserRoles.WAREHOUSE, this.UserRoles.HasAnyRole],
        children: [
          {
            to: '/warehouses',
            icon: 'home_work',
            text: this.$t('Pages.Warehouses.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.WAREHOUSE, this.UserRoles.HasAnyRole]
          },
          {
            to: '/products',
            icon: 'mdi-package-down',
            text: this.$t('Pages.Products.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.WAREHOUSE, this.UserRoles.HasAnyRole]
          },
          {
            to: '/product-sizes',
            icon: 'mdi-arrow-expand-horizontal',
            text: this.$t('Pages.ProductSizes.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.WAREHOUSE, this.UserRoles.HasAnyRole]
          },
          {
            to: '/manufacturers',
            icon: 'mdi-truck',
            text: this.$t('Pages.Manufacturers.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.WAREHOUSE, this.UserRoles.HasAnyRole]
          },
          {
            to: '/groupations',
            icon: 'mdi-account-multiple',
            text: this.$t('Pages.Groupations.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.WAREHOUSE, this.UserRoles.HasAnyRole]
          },
          {
            to: '/user-checkout-forms',
            icon: 'mdi-format-list-checkbox',
            text: this.$t('Pages.UserCheckoutForms.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.WAREHOUSE, this.UserRoles.HasAnyRole]
          },
        ]
      },
      {
        to: '/overtime',
        icon: 'mdi-alarm',
        text: this.$t('Pages.ScheduledOvertimes.title'),
        roles: [this.UserRoles.ADMIN, this.UserRoles.REVISER, this.UserRoles.OVERTIME]
      },
      {
        to: '/support-tickets',
        icon: 'contact_support',
        text: this.$t('Pages.SupportTickets.title'),
        roles: [this.UserRoles.ADMIN]
      },
      {
        to: '/request',
        icon: 'mdi-briefcase-remove',
        text: this.$t('Pages.Vacations.make_request')
      },
      {
        icon: 'mdi-book-open',
        text: this.$t('Pages.RecordBooks.title'),
        roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.RECORD_BOOKS],
        children: [
          {
            to: '/document-types',
            icon: 'mdi-book-open',
            text: this.$t('Pages.DocumentTypes.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.RECORD_BOOKS]
          },
          {
            to: '/partners',
            icon: 'mdi-account-supervisor',
            text: this.$t('Pages.Partners.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.RECORD_BOOKS]
          },
          {
            to: '/real-locations',
            icon: 'mdi-map-marker',
            text: this.$t('Pages.RealLocations.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.RECORD_BOOKS]
          },
          {
            to: '/record-book-types',
            icon: 'mdi-book-open',
            text: this.$t('Pages.RecordBookTypes.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.RECORD_BOOKS]
          },
          {
            to: '/transport-types',
            icon: 'mdi-truck',
            text: this.$t('Pages.TransportTypes.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.RECORD_BOOKS]
          },
          // {
          //   to: '/record-book-files',
          //   icon: 'mdi-book-open',
          //   text: this.$t('Pages.RecordBookFiles.title'),
          //   roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.RECORD_BOOKS]
          // },
          {
            to: '/record-books',
            icon: 'mdi-book-open',
            text: this.$t('Pages.RecordBooks.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.RECORD_BOOKS]
          }
        ]
      },
      {
        icon: 'mdi-flash',
        text: this.$t('Pages.Electricity.title'),
        roles: [this.UserRoles.ADMIN, this.UserRoles.ELECTRICIAN],
        children: [
          {
            to: '/electricity-constants',
            icon: 'mdi-infinity',
            text: this.$t('Pages.ElectricityConstants.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.ELECTRICIAN]
          },
          {
            to: '/electricity-suppliers',
            icon: 'mdi-ev-station',
            text: this.$t('Pages.ElectricitySuppliers.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.ELECTRICIAN]
          },
          {
            to: '/electricity-bills',
            icon: 'mdi-receipt',
            text: this.$t('Pages.ElectricityBills.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.ELECTRICIAN]
          },
          {
            to: '/electricity-stats',
            icon: 'mdi-finance',
            text: this.$t('Pages.ElectricityStats.title'),
            roles: [this.UserRoles.ADMIN, this.UserRoles.ELECTRICIAN]
          },
        ]
      },
    ];
  },
  beforeDestroy () {
    clearTimeout(this.$options.interval);
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    logoutTimer(){
        if(!this.hasAnyRole([this.UserRoles.DIRECTOR, this.UserRoles.REVISER, this.UserRoles.ADMIN, this.UserRoles.LOGISTIC, this.UserRoles.RECORD_BOOKS, this.UserRoles.TRAVEL_WARRANTS])){
            console.log("Timer set!");
            this.$options.interval = setTimeout(this.logout, this.timeout * 1000);
        }
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }

    .user-name{
      font-size: 16px!important;
      word-break: break-word;
      max-width: 63%;
    }
  }
</style>
